export default __webpack_public_path__ + "static/media/C_Carpet.cd57a312.jpg";